const rankingOptions = $('input[type=radio][name=ranking__team]');
const rankingOptionsDetails = $('.section--team').toArray();
const $veja = $('[data-equipe-veja]');

/**
 * Checks if the details for a team is showing.
 * If so, hides it.
 */
function hideTeamRanking() {
  /* eslint-disable arrow-body-style */
  const selectedOption = rankingOptionsDetails.filter((option) => { return option.classList.contains('active'); });
  selectedOption.map(option => option.classList.remove('active'));
}
/* eslint-disable comma-dangle */
rankingOptions.change((e) => {
  e.stopPropagation();
  hideTeamRanking();
  const optionSelected = e.currentTarget.parentNode;
  $(`[data-section-team=${optionSelected.dataset.liTeam}]`)[0].classList.add('active');
  $('html, body').animate({
    scrollTop: $('.ranking__groups').offset().top + $('.ranking__groups').height()
  }, 500);
});

const $navEquipes = $('[data-nav-equipe]');

const navEquipesClick = (e) => {
  e.stopPropagation();
  hideTeamRanking();
  const optionSelected = $(e.currentTarget);
  $(`[data-section-team=${optionSelected.attr('data-nav-equipe')}]`)[0].classList.add('active');
  $('html, body').animate({
    scrollTop: $('.nav').offset().top + ($('.nav').height() - 90)
  }, 500);
};

$navEquipes.click(navEquipesClick);

const VejaMaisClick = (e) => {
  e.stopPropagation();
  hideTeamRanking();
  const $target = $(e.currentTarget);
  const $expande = $(`[data-section-equipe="${$target.attr('data-equipe-veja')}"]`).find('.criterios');

  if ($expande.is('.criterios--ativo')) {
    $target.text('Veja mais +');

    $expande
      .removeClass('criterios--ativo');
  } else {
    $target.text('Veja menos -');

    $expande
      .addClass('criterios--ativo');
  }
};

$navEquipes.click(navEquipesClick);
$veja.click(VejaMaisClick);



// WEBPACK FOOTER //
// local_static/templates/guias/2018/assets/scripts/rankingModule.js